import { CSSProperties } from 'react';
import { GroupByPropertyDisplay, FilteredElementRecord } from '@fullstory/renderer-shared';

export interface ClickMapDisplayOptions {
  /**
   * Whether to display an engagement map around each indicator's element helping show most click areas of page.
   */
  showEngagementMaps: boolean;
  /**
   * Force a mode which make all rank indicators visible at all times and black in color. <p/>
   * <b>Note:</b> This will ignore click type colors and will always be black.
   */
  heatmapMode: boolean;
  /**
   * If the click map will be used in an export mode. Export mode will show always indicators and not show the
   * color map widget on the right of the page.
   */
  exportMode: boolean;
  /**
   * If rank indicators should use CSS transitions.
   */
  useTransitions: boolean;
  /**
   * Setting to true will allow users to hover and click on the actual element vs just the rank indicators. A click
   * on the element will be treated the same as a click on a rank indicator.
   */
  enableMouseOverHighlights: boolean;
  /**
   * If true, then the related possible elements can also be highlighted.
   */
  allowHighlightRelatedElements: boolean;
  /**
   * If set, indicates the focus selectors for which all other interactions and properties should be contained within.
   */
  focusSelectors?: string[];
  /**
   * If set, indicates group by property display configuration.
   */
  groupByProperty?: GroupByPropertyDisplay;
}

export interface ClickAreaOverlayDisplayOptions {
  displayIndicators: boolean;
  focusSelectors?: string[];
  groupByProperty?: GroupByPropertyDisplay;
}

export interface ElementConversionStats {
  /** element ident (id + optional property value) => ConversionOverlayFunnelDetails */
  elementStats: { [key: string]: ConversionOverlayFunnelDetails };
}

export function filteredElemIdIdent(namedElement: FilteredElementRecord): string {
  const namedElementId = namedElement.namedElementRecord.namedElement?.id ?? '';
  return elemIdIdent(namedElementId, namedElement.propertyValue);
}

export function elemIdIdent(namedElementId: string, propertyValue: string | undefined): string {
  if (propertyValue === undefined) {
    return namedElementId;
  }
  return `${namedElementId}!!${propertyValue}`;
}

export interface ConversionOverlayFunnelDetails {
  /** Number of users who clicked and converted on related element / total number of users who clicked on any named element. */
  conversionRate: number;
  numUsersClicked: number;
  numUsersConverted: number;
  namedElementId: string;
  propertyValue: string | undefined;
}

export interface ConversionOverlayDisplayOptions {
  elementConversionStats?: ElementConversionStats;
  conversionEventLabel: string;
  exportMode: boolean;
  rankIndicatorStyleOverrides?: CSSProperties;
  focusSelectors?: string[];
  groupByProperty?: GroupByPropertyDisplay;
}

export interface HeatmapElemStatsText {
  clickText: string;
  totalClickText: string;
  userClickText: string;
  totalUserClickText: string;
}
